import React, { useState, useEffect, forwardRef } from "react";
import { Image, Descriptions, Col, Row, Divider, QRCode, Space } from "antd";
import { Container } from "react-bootstrap";
import Moment from "react-moment";
import { Parser } from 'html-to-react';
import { TelephoneInboundFill, GeoAltFill } from "react-bootstrap-icons";
import DocumentHeader from "./DocumentHeader";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ImResultView = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var im_result = _ref.im_result,
      customer = _ref.customer,
      business_account_medical_item = _ref.business_account_medical_item;

  var calculate_age = function calculate_age(dob) {
    // Calculate the difference in milliseconds between the current date and the provided date of birth
    var diff_ms = Date.now() - dob.getTime(); // Create a new Date object representing the difference in milliseconds and store it in the variable age_dt (age Date object)

    var age_dt = new Date(diff_ms); // Calculate the absolute value of the difference in years between the age Date object and the year 1970 (UNIX epoch)

    return Math.abs(age_dt.getUTCFullYear() - 1970);
  };

  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    id: "printable",
    children: [/*#__PURE__*/_jsx(DocumentHeader, {
      title: business_account_medical_item.label
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsx("fieldset", {
          children: /*#__PURE__*/_jsxs(Descriptions, {
            bordered: true,
            labelStyle: {
              color: "#484848"
            },
            size: "small",
            column: 2,
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "ID PATIENT"
              }),
              children: customer.idnumber
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "NOM PATIENT"
              }),
              children: customer.firstname + " " + customer.lastname
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "AGE"
              }),
              children: customer.birthdate
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "INDICATION CLINIQUE"
              }),
              children: im_result && im_result.clinic_indication
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "PRESCRIPTEUR"
              }),
              children: im_result && im_result.prescriber && im_result.prescriber.name
            })]
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          className: "imr_content",
          style: {
            fontSize: "14px"
          },
          children: Parser().parse(im_result.cr)
        })]
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: {
          span: 5,
          offset: 6
        },
        md: {
          span: 5,
          offset: 6
        },
        sm: {
          span: 5,
          offset: 6
        },
        children: /*#__PURE__*/_jsx("div", {
          style: {
            textAlign: "right"
          },
          children: /*#__PURE__*/_jsx(Space, {
            direction: "vertical",
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(Moment, {
                date: im_result.created_at,
                format: "DD/MM/YYYY"
              })
            })
          })
        })
      }), /*#__PURE__*/_jsxs(Col, {
        lg: {
          span: 7,
          offset: 6
        },
        md: {
          span: 7,
          offset: 6
        },
        sm: {
          span: 7,
          offset: 6
        },
        children: [/*#__PURE__*/_jsx("h6", {
          children: /*#__PURE__*/_jsx("b", {
            children: "Medecin interprete"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: im_result && im_result.translator && "Dr " + im_result.translator.firstname + " " + im_result.translator.lastname
        })]
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsxs("p", {
          style: {
            color: "#777777",
            fontSize: "12px"
          },
          children: ["Medvie, ", /*#__PURE__*/_jsx(GeoAltFill, {
            size: 15
          }), " Kaporo centre, Kip\xE9, Conakry Guin\xE9e | ", /*#__PURE__*/_jsx(TelephoneInboundFill, {
            size: 15
          }), " 620 000 000"]
        })
      })
    })]
  });
});
export default ImResultView;